// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectSourceMappingMessage } from "../../../../Utils/DirectMessages/DirectSourceMappingMessage.js"
import { SourceGroup } from "../Groups/GroupsImport.js"
export let SourceListProcessor = function (parentDecoder)
{
    MessageProcessorBase.call(this)
    this.decoder = parentDecoder
}

SourceListProcessor.prototype = Object.create(MessageProcessorBase.prototype)

SourceListProcessor.prototype.decode = function (fs)
{
    let ff = FieldsFactory
    let decoder = this.decoder

    let routeId = fs.GetValue(ff.FIELD_ROUTE_ID)

    let smm = new DirectSourceMappingMessage()
    smm.RouteId = routeId

    let sourceMap = decoder.SourceMap

    let sourceDict = sourceMap[routeId]
    if (!sourceDict) sourceMap[routeId] = sourceDict = {}

    let groupArr = fs.GetGroups(FieldsFactory.SOURCE_GROUP, SourceGroup)
    for (let i = 0, len = groupArr.length; i < len; i++)
    {
        let group = groupArr[i]
        let sourceId = group.getSourceId()
        let sourceName = group.getSource()
        let sourceExternalId = group.getExternalSourceId()

        sourceDict[sourceId] = sourceName
        smm.SourceIDs.push(sourceId)
        smm.SourceNames.push(sourceName)
        smm.SourceExternalIds.push(sourceExternalId)
    }

    return [smm]
}